import TextField from '@mui/material/TextField';
import is from '@sindresorhus/is';
import debounce from 'lodash.debounce';
import type { ChangeEvent, FunctionComponent, MutableRefObject } from 'react';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';

import { route } from '../../../pages/learning-opportunities/constants';
import { defaultSearchParam } from './constants';

type SearchInputProps = {
    readonly inputRef?: MutableRefObject<HTMLInputElement | null>;
    readonly placeholder?: string;
};

export const SearchInput: FunctionComponent<SearchInputProps> = ({ inputRef, placeholder }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const searchTerm = searchParams.get(route.searchParams.searchTerm) ?? '';
    const [searchTermState, setSearchTermState] = useState(searchTerm);

    useEffect(() => {
        if (!searchParams.has(route.searchParams.searchTerm)) setSearchTermState('');
    }, [searchParams]);

    const updateUrl = (searchInput: string): void => {
        const search = new URLSearchParams(searchParams);
        if (is.nonEmptyString(searchInput)) {
            search.set(defaultSearchParam, searchInput);
        } else {
            search.delete(defaultSearchParam);
        }
        setSearchParams(search, { replace: true });
    };

    const handler = debounce(updateUrl, 200);

    const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
        const searchInput = e.target.value;

        setSearchTermState(searchInput);
        handler(searchInput);
    };

    return (
        <TextField
            autoComplete="off"
            InputProps={{ 'aria-label': 'Search term' }}
            inputRef={inputRef}
            placeholder={placeholder ?? ''}
            size="small"
            sx={{ width: '100%' }}
            value={searchTermState}
            onChange={onChange}
        />
    );
};
